var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 1,
    y: 1,
    stroke: "#3E70DA",
    strokeWidth: 2,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E70DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.667 34.667v1.666a5 5 0 0 0 5 5h16.666a5 5 0 0 0 5-5v-1.666M34.667 28 28 34.667m0 0L21.333 28M28 34.667v-20"
  })));
};
export default SvgDownload;